import * as Actions from "../../actions/cases/createCaseActions";

const initialState = {
  isLoading: false,
  caseContact: "",
  type: "",
  specificType: "",
  subject: "",
  details: "",
  contractAcc: "",
  contractAccounts: [],
  invoiceNo: "",
  esn: "",
  vin: "",
  vehicleLabel: "",
  caseContactErr: false,
  typeArr: [],
  specificTypeArr: [],
  newCase: {},
  caseID: "",
  disableSubmit: true,
  isModalOpen: false,
  cancelCaseToggle: false,
  typeErr: false,
  specificTypeErr: false,
  subjectErr: false,
  detailsErr: false,
  newCaseErr: false,
  mandatoryFields: ["subject", "details", "caseContact"],
  helpCenterLink: "",
  handleAttachemntSubmit: false,
  attachmentErrorNotification: false,
  attachmentReset: false,
  attachmentFileSizeError: false,
  attachmentLoader: false,
  attachmentCheck: false,
  cancelDisable: true,
  disableFields: false,
  tryAgain: false,
  fileStatusResponse: [],
  fileName: [],
};

const createCaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SET_CREATE_CASE_LOADER:
      return {
        ...state,
        isLoading: action.value,
      };
    // case Actions.GET_TYPE_ARR:
    // case Actions.GET_SPECIFIC_TYPE_ARR:
    //   return {
    //     ...state,
    //     isLoading: true,
    //   };
    case Actions.SET_CREATE_CASE_FIELDS:
    case Actions.SET_CREATE_CASE_FIELDS_ERR:
      return {
        ...state,
        [action.field]: action.value,
      };

    case Actions.SET_CREATE_CASE_CONTRACT_ACCOUNTS:
      return {
        ...state,
        contractAccounts: action.response,
      };

    case Actions.SET_NEW_CASE:
      return {
        ...state,
        newCase: action.response,
        caseID: action.response.id,
      };

    case Actions.SET_TYPE_ARR:
      return {
        ...state,
        typeArr: action.response,
      };

    case Actions.SET_SPECIFIC_TYPE_ARR:
      return {
        ...state,
        specificTypeArr: action.response,
        esn: "",
        vin: "",
        vehicleLabel: "",
        // contractAcc: "",
        invoiceNo: "",
      };

    case Actions.SET_SUBMIT_BUTTON:
      return {
        ...state,
        disableSubmit: action.value,
      };

    case Actions.SET_MODAL_OPEN:
      return {
        ...state,
        isModalOpen: action.value,
      };

    case Actions.SET_CANCEL_CASE_TOGGLE:
      return {
        ...state,
        cancelCaseToggle: action.value,
      };

    case Actions.SUBMIT_ATTACHMENT:
      return {
        ...state,
        handleAttachemntSubmit: action.value,
      };

    case Actions.ATTACHMENT_ERROR_NOTIFICATION:
      return {
        ...state,
        attachmentErrorNotification: action.value,
      };

    case Actions.ATTACHMENT_RESET:
      return {
        ...state,
        attachmentReset: action.value,
      };

    case Actions.ATTACHMENT_SIZE_ERROR:
      return {
        ...state,
        attachmentFileSizeError: action.value,
      };

    case Actions.ATTACHMENT_LOADER:
      return {
        ...state,
        attachmentLoader: action.value,
      };

    case Actions.ATTACHMENT_CHECK:
      return {
        ...state,
        attachmentCheck: action.value,
      };

    case Actions.CANCEL_DISABLE:
      return {
        ...state,
        cancelDisable: action.value,
      };

    case Actions.TRY_AGAIN:
      return {
        ...state,
        tryAgain: action.value,
      };

    case Actions.DISABLE_FIELDS:
      return {
        ...state,
        disableFields: action.value,
      };

    case Actions.CREATE_CASE_RESET:
      return initialState;

    case Actions.FILE_STATUS_RESPONSE:
      return {
        ...state,
        fileStatusResponse: action.value,
      };

    case Actions.FILE_NAME:
      return {
        ...state,
        fileName: action.value,
      };

    default:
      return state;
  }
};

export default createCaseReducer;
